const DAWN_CART_TAGS = ['cart-drawer', 'cart-items', 'cart-drawer-items', 'cart-notification'];
const DAWN_REFRESHED_SECTIONS = new Set([
  'cart-drawer:cart-drawer',
  'cart-drawer-items:CartDrawer',
  'cart-items:main-cart-items',
]);

function initCodexMobileFixes() {
  if (!document.getElementById('codex-cart-accordion-fixes')) {
    const style = document.createElement('style');
    style.id = 'codex-cart-accordion-fixes';
    style.textContent = `
      #shopify-pc__banner.shopify-pc__banner__dialog {
        top: auto !important;
        right: max(1.6rem, env(safe-area-inset-right)) !important;
        bottom: max(1.6rem, env(safe-area-inset-bottom)) !important;
        left: auto !important;
        width: min(36rem, calc(100vw - 3.2rem)) !important;
        min-width: 0 !important;
        max-width: 36rem !important;
        max-height: calc(100vh - 3.2rem) !important;
        padding: 1.8rem !important;
        overflow: auto !important;
        border: 0.1rem solid rgb(0, 0, 0) !important;
        border-radius: 0.5rem !important;
        background: rgb(255, 255, 255) !important;
        color: rgb(0, 0, 0) !important;
        box-shadow: none !important;
        box-sizing: border-box !important;
        transform: none !important;
        font-size: 1.2rem !important;
        line-height: 1.4 !important;
      }

      #shopify-pc__banner .shopify-pc__banner__wrapper {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 0 !important;
        width: 100% !important;
      }

      #shopify-pc__banner .shopify-pc__banner__body {
        width: 100% !important;
        margin: 0 0 1.2rem !important;
        color: rgb(0, 0, 0) !important;
      }

      #shopify-pc__banner .shopify-pc__banner__body p,
      #shopify-pc__banner .shopify-pc__banner__body span,
      #shopify-pc__banner .shopify-pc__banner__body strong,
      #shopify-pc__banner .shopify-pc__banner__body a {
        color: rgb(0, 0, 0) !important;
      }

      #shopify-pc__banner .shopify-pc__banner__btns {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 0.8rem !important;
        width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
      }

      #shopify-pc__banner.shopify-pc__banner__dialog button {
        width: 100% !important;
        min-width: 0 !important;
        min-height: 3.4rem !important;
        margin: 0 !important;
        padding: 0.7rem 1rem !important;
        border-radius: 0.5rem !important;
        box-sizing: border-box !important;
        line-height: 1.2 !important;
      }

      #shopify-pc__banner .shopify-pc__banner__btn-accept {
        border: 0.1rem solid rgb(0, 0, 0) !important;
        background: rgb(0, 0, 0) !important;
        color: rgb(255, 255, 255) !important;
      }

      #shopify-pc__banner .shopify-pc__banner__btn-decline,
      #shopify-pc__banner .shopify-pc__banner__btn-manage-prefs,
      #shopify-pc__banner .shopify-pc__prefs__header-actions button {
        border: 0.1rem solid rgb(0, 0, 0) !important;
        background: rgb(255, 255, 255) !important;
        color: rgb(0, 0, 0) !important;
      }

      product-info .codex-product-desktop-nav,
      product-info .codex-product-media-counter,
      product-info .product__media-wrapper .slider-counter {
        display: none !important;
      }

      product-info .product__title h1,
      product-info .product__title h2,
      [id^='MainProduct-'] .product__title h1,
      [id^='MainProduct-'] .product__title h2 {
        text-transform: none !important;
      }

      product-info .codex-mobile-media-nav {
        align-items: center !important;
        justify-content: center !important;
        color: rgb(0, 0, 0) !important;
        font-family: var(--font-body-family) !important;
        font-size: 1.1rem !important;
        line-height: 1 !important;
        white-space: nowrap !important;
      }

      product-info .codex-mobile-media-nav button {
        color: rgba(0, 0, 0, 0.35) !important;
      }

      product-info .codex-mobile-media-nav button[hidden] {
        display: none !important;
      }

      @media screen and (min-width: 990px) {
        product-info .product__info-container > .codex-mobile-media-nav {
          grid-column: 1 !important;
          grid-row: 2 !important;
          display: none !important;
          width: 100% !important;
          min-height: 1.8rem !important;
          margin: 0 !important;
          align-self: start !important;
          justify-self: stretch !important;
          transform: none !important;
        }

        [id^='MainProduct-'] .product__info-container > [id^='price-'] {
          grid-column: 2 !important;
          grid-row: 1 !important;
          margin-bottom: 0 !important;
          transform: none !important;
        }

        [id^='MainProduct-'] .product__info-container {
          row-gap: 0 !important;
        }

        [id^='MainProduct-'] .product__info-container > div:has(> product-form) {
          grid-column: 2 !important;
          grid-row: 2 !important;
          margin-top: 8px !important;
          transform: none !important;
        }

        [id^='MainProduct-'] .product__info-container > .product__tax {
          grid-column: 2 !important;
          grid-row: 3 !important;
          justify-self: end !important;
          margin: 4px 0 0 !important;
          transform: none !important;
          text-align: right !important;
        }

        [id^='MainProduct-'] .product__info-container > .codex-product-accordions {
          grid-column: 2 !important;
          grid-row: 4 !important;
          margin-top: 12px !important;
          transform: none !important;
        }

        [id^='MainProduct-'] .product__info-container > .codex-desktop-size-chart {
          position: static !important;
          top: auto !important;
          right: auto !important;
          bottom: auto !important;
          left: auto !important;
          grid-column: 1 !important;
          grid-row: 4 !important;
          align-self: start !important;
          width: 36rem !important;
          max-width: 100% !important;
          margin: 0 !important;
          transform: translateY(14px) !important;
        }

        [id^='MainProduct-'] .codex-desktop-size-chart__title,
        [id^='MainProduct-'] .codex-desktop-size-chart__title .codex-accordion-title,
        [id^='MainProduct-'] .codex-desktop-size-chart .codex-size-chart,
        [id^='MainProduct-'] .codex-desktop-size-chart .codex-size-chart__table-wrap,
        [id^='MainProduct-'] .codex-desktop-size-chart table {
          min-height: 0 !important;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }

        [id^='MainProduct-'] .codex-desktop-size-chart__title {
          margin-bottom: 2px !important;
        }

        [id^='MainProduct-'] .product__info-container:has(> variant-selects) > variant-selects {
          grid-column: 2 !important;
          grid-row: 2 !important;
        }

        [id^='MainProduct-'] .product__info-container:has(> variant-selects) > div:has(> product-form) {
          grid-row: 3 !important;
        }

        [id^='MainProduct-'] .product__info-container:has(> variant-selects) > .product__tax {
          grid-row: 4 !important;
        }

        [id^='MainProduct-'] .product__info-container:has(> variant-selects) > .codex-product-accordions {
          grid-row: 5 !important;
        }

        [id^='MainProduct-'] .product__info-container:has(> variant-selects) > .codex-desktop-size-chart {
          grid-row: 5 !important;
        }
      }

      @media screen and (min-width: 990px) {
        product-info .codex-desktop-size-chart {
          top: 3.2rem !important;
        }
      }

      @media screen and (max-width: 749px) {
        #shopify-pc__banner.shopify-pc__banner__dialog {
          right: max(1rem, env(safe-area-inset-right)) !important;
          bottom: max(1rem, env(safe-area-inset-bottom)) !important;
          width: calc(100vw - 2rem) !important;
          max-width: 36rem !important;
          max-height: calc(100vh - 2rem) !important;
          padding: 1.4rem !important;
        }

        product-info .product__info-container {
          display: grid !important;
          grid-template-columns: auto minmax(0, 1fr) !important;
          column-gap: 0.8rem !important;
          align-items: start !important;
        }

        product-info .product__info-container > * {
          grid-column: 1 / -1;
        }

        product-info .product__info-container > .product__title {
          grid-column: 1 !important;
          grid-row: 1 !important;
          display: contents !important;
          width: auto !important;
          margin: 0 !important;
        }

        product-info .product__title > h1 {
          grid-column: 1 !important;
          grid-row: 1 !important;
          justify-self: start !important;
          align-self: start !important;
          max-width: 100% !important;
          margin: 0 !important;
          text-align: left !important;
          overflow: visible !important;
          white-space: nowrap !important;
          line-height: 1.15 !important;
        }

        [id^='MainProduct-'] product-info .product__title > h1 {
          grid-column: 1 !important;
          grid-row: 1 !important;
          justify-self: start !important;
          align-self: start !important;
          margin: 0 !important;
          text-align: left !important;
          white-space: nowrap !important;
          line-height: 1.15 !important;
        }

        product-info .product__title .codex-product-vendor {
          display: none !important;
        }

        product-info .product__info-container > [id^='price-'] {
          grid-column: 1 !important;
          grid-row: 2 !important;
          justify-self: start !important;
          align-self: start !important;
          margin: 0 !important;
          text-align: left !important;
          font-size: 12px !important;
        }

        [id^='MainProduct-'] product-info .product__info-container > [id^='price-'] {
          grid-column: 1 !important;
          grid-row: 2 !important;
          justify-self: start !important;
          align-self: start !important;
          margin: 0 !important;
          text-align: left !important;
          font-size: 12px !important;
        }

        product-info .codex-mobile-media-nav {
          grid-column: 2 !important;
          grid-row: 1 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-self: end !important;
          align-self: start !important;
          margin-top: 0 !important;
          transform: translateY(-0.28rem) !important;
          gap: 0.8rem !important;
          min-height: 1.6rem !important;
          font-size: 1.1rem !important;
          line-height: 1.3 !important;
        }

        [id^='MainProduct-'] product-info .codex-mobile-media-nav {
          grid-column: 2 !important;
          grid-row: 1 !important;
          justify-self: end !important;
          align-self: start !important;
          margin-top: 0 !important;
          transform: translateY(-0.28rem) !important;
        }

        product-info .codex-mobile-media-nav button {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 1.8rem !important;
          height: 1.8rem !important;
          padding: 0 !important;
          border: 0 !important;
          background: transparent !important;
          color: rgba(0, 0, 0, 0.35) !important;
          font: inherit !important;
          line-height: 1 !important;
        }

        product-info .codex-mobile-media-nav[data-count='1'] button {
          display: none !important;
        }

        product-info .product__info-container [id^='price-'] .price,
        product-info .product__info-container [id^='price-'] .price__container {
          justify-content: flex-start !important;
          text-align: left !important;
        }

        product-info .product__info-container [id^='price-'] .price--large {
          font-size: 12px !important;
          line-height: 1 !important;
        }

        [id^='MainProduct-'] product-info .product__info-container [id^='price-'] .price,
        [id^='MainProduct-'] product-info .product__info-container [id^='price-'] .price__container {
          justify-content: flex-start !important;
          text-align: left !important;
        }

        [id^='MainProduct-'] product-info .product__info-container [id^='price-'] .price--large,
        [id^='MainProduct-'] product-info .product__info-container [id^='price-'] .price-item {
          font-size: 12px !important;
          line-height: 1 !important;
        }

        product-info .product__info-container [id^='price-'] .price-item,
        product-info .product__info-container [id^='price-'] .price__regular,
        product-info .product__info-container [id^='price-'] .price__sale,
        [id^='MainProduct-'] product-info .product__info-container [id^='price-'] .price-item,
        [id^='MainProduct-'] product-info .product__info-container [id^='price-'] .price__regular,
        [id^='MainProduct-'] product-info .product__info-container [id^='price-'] .price__sale {
          font-size: 12px !important;
          line-height: 1 !important;
        }

        product-info .product__info-container > .product__tax {
          grid-column: 1 / -1 !important;
          grid-row: auto !important;
          justify-self: end !important;
          align-self: start !important;
          width: auto !important;
          max-width: 100% !important;
          margin-top: 0.4rem !important;
          text-align: left !important;
          width: 100% !important;
          font-size: 1.1rem !important;
          line-height: 1.3 !important;
        }

        product-info .product__info-container > .product__tax *,
        [id^='MainProduct-'] product-info .product__title .codex-product-vendor,
        [id^='MainProduct-'] product-info .product__info-container > .product__tax,
        [id^='MainProduct-'] product-info .product__info-container > .product__tax * {
          font-size: 1.1rem !important;
          line-height: 1.3 !important;
        }

        [id^='MainProduct-'] product-info .product__info-container > .product__tax {
          justify-self: start !important;
          width: 100% !important;
          margin-top: 0.4rem !important;
          text-align: left !important;
        }

        product-info .product__info-container > div:has(> product-form) {
          margin-top: -0.6rem !important;
        }

        [id^='MainProduct-'] .product__info-container {
          row-gap: 0 !important;
        }

        [id^='MainProduct-'] .product__info-container > div:has(> product-form) {
          margin-top: 5px !important;
        }

        [id^='MainProduct-'] .product__info-container > div:has(> product-form),
        [id^='MainProduct-'] .product__info-container > div:has(> product-form) > product-form,
        [id^='MainProduct-'] .product__info-container > div:has(> product-form) .product-form,
        [id^='MainProduct-'] .product-form__buttons {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
          overflow: visible !important;
        }

        [id^='MainProduct-'] .product-form__buttons {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
          gap: 0.6rem !important;
          align-items: stretch !important;
          justify-content: stretch !important;
          margin-right: 0 !important;
          margin-left: 0 !important;
        }

        [id^='MainProduct-'] .product-form__buttons > *,
        [id^='MainProduct-'] .product-form__buttons button,
        [id^='MainProduct-'] .product-form__buttons shopify-payment-button,
        [id^='MainProduct-'] .product-form__buttons shopify-accelerated-checkout,
        [id^='MainProduct-'] .product-form__buttons shopify-paypal-button,
        [id^='MainProduct-'] .product-form__buttons .paypal-buttons,
        [id^='MainProduct-'] .product-form__buttons .component-frame {
          display: block !important;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
          flex: 1 1 0 !important;
        }
      }

      #main-cart-footer .codex-cart-note .field__input,
      #main-cart-footer .codex-cart-note .field__input:focus,
      #main-cart-footer .codex-cart-note .field__input:focus-visible {
        border-radius: 0.5rem !important;
      }

      #main-cart-footer .cart__checkout-button,
      #main-cart-footer .cart__dynamic-checkout-buttons button,
      #main-cart-footer .cart__dynamic-checkout-buttons iframe,
      #main-cart-footer .cart__dynamic-checkout-buttons [role='button'],
      .cart-drawer .cart__checkout-button,
      .cart-drawer .cart__dynamic-checkout-buttons button,
      .cart-drawer .cart__dynamic-checkout-buttons iframe,
      .cart-drawer .cart__dynamic-checkout-buttons [role='button'] {
        border-radius: 0.5rem !important;
      }

      #main-cart-footer shopify-accelerated-checkout-cart,
      .cart-drawer shopify-accelerated-checkout-cart {
        --shopify-accelerated-checkout-button-border-radius: 5px;
      }

      .codex-product-accordions,
      .codex-product-accordions *,
      .codex-product-benefits,
      .codex-product-benefits * {
        box-sizing: border-box;
      }

      .codex-product-accordion__content,
      .codex-product-accordion__content .rte,
      .codex-product-accordion__content .metafield-rich_text_field,
      .codex-detail-list,
      .codex-care-list {
        max-width: 100%;
        overflow-wrap: anywhere;
        word-break: normal;
      }

      .codex-product-accordion__content img,
      .codex-product-accordion__content svg {
        max-width: 100%;
      }

      @media screen and (max-width: 749px) {
        .drawer__footer #dynamic-checkout-cart ul {
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          gap: 0.4rem !important;
          align-items: stretch;
        }

        .drawer__footer #dynamic-checkout-cart ul > li {
          flex: 1 1 0 !important;
          flex-basis: 0 !important;
          width: auto !important;
          min-width: 0 !important;
        }

        .drawer__footer #dynamic-checkout-cart [role='button'],
        .drawer__footer #dynamic-checkout-cart button,
        .drawer__footer #dynamic-checkout-cart iframe {
          min-width: 0 !important;
          max-width: 100% !important;
        }

        .codex-product-accordions,
        .codex-product-accordion__content,
        .accordion__content:has(.codex-size-chart),
        .codex-size-chart,
        .codex-shipping-table,
        .codex-size-chart__table-wrap,
        .codex-shipping-table__wrap {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          overflow-x: hidden !important;
          -webkit-overflow-scrolling: auto;
          overscroll-behavior-x: none;
        }

        .codex-size-chart,
        .codex-size-chart__table-wrap {
          display: block;
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        .codex-size-chart table,
        .codex-shipping-table table {
          display: table;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          table-layout: fixed !important;
          border-collapse: collapse;
        }

        .codex-size-chart th,
        .codex-size-chart td,
        .codex-shipping-table th,
        .codex-shipping-table td {
          min-width: 0;
          white-space: normal;
          overflow-wrap: anywhere;
          word-break: normal;
          padding-left: 0.12rem;
          padding-right: 0.12rem;
          font-size: clamp(0.72rem, 2.35vw, 0.98rem);
          line-height: 1.2;
        }

        .codex-size-chart th:first-child,
        .codex-size-chart td:first-child,
        .codex-shipping-table th:first-child,
        .codex-shipping-table td:first-child {
          width: 15%;
        }

        .codex-size-chart th:not(:first-child),
        .codex-size-chart td:not(:first-child),
        .codex-shipping-table th:not(:first-child),
        .codex-shipping-table td:not(:first-child) {
          width: 17%;
        }

        .codex-size-chart td:not(:first-child),
        .codex-shipping-table td:not(:first-child) {
          white-space: nowrap;
          font-size: clamp(0.68rem, 2.15vw, 0.92rem);
        }
      }

      @media screen and (max-width: 989px) {
        product-info .product__info-container {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) !important;
          column-gap: 0 !important;
          row-gap: 0 !important;
          width: 100% !important;
          min-width: 0 !important;
          max-width: 100% !important;
        }

        product-info .product__info-container > * {
          grid-column: 1 !important;
          min-width: 0 !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }

        product-info .product__info-container > .product__title {
          display: contents !important;
          width: auto !important;
          margin: 0 !important;
        }

        product-info .product__title > h1 {
          grid-column: 1 !important;
          grid-row: 1 !important;
          width: 100% !important;
          max-width: 100% !important;
          margin: 0 !important;
          text-align: left !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          line-height: 1.15 !important;
        }

        product-info .product__title > a,
        product-info .product__title .codex-product-vendor,
        product-info .codex-mobile-media-nav {
          display: none !important;
        }

        product-info .product__info-container > [id^='price-'] {
          grid-column: 1 !important;
          grid-row: 2 !important;
          justify-self: start !important;
          width: 100% !important;
          margin: 0 !important;
          text-align: left !important;
          font-size: 12px !important;
        }

        product-info .product__info-container > [id^='price-'] .price,
        product-info .product__info-container > [id^='price-'] .price__container {
          justify-content: flex-start !important;
          text-align: left !important;
        }

        product-info .product__info-container > [id^='price-'] .price--large,
        product-info .product__info-container > [id^='price-'] .price-item {
          font-size: 12px !important;
          line-height: 1 !important;
        }

        product-info .product__info-container > div:has(> product-form) {
          grid-column: 1 !important;
          grid-row: 3 !important;
          width: 100% !important;
          max-width: 100% !important;
          margin-top: 5px !important;
          margin-bottom: 0 !important;
        }

        product-info .product__info-container > .product__tax {
          grid-column: 1 !important;
          grid-row: 4 !important;
          justify-self: start !important;
          width: 100% !important;
          max-width: 100% !important;
          margin: 5px 0 0 !important;
          text-align: left !important;
        }

        product-info .product__info-container > div:has(> product-form),
        product-info .product__info-container > div:has(> product-form) > product-form,
        product-info .product__info-container > div:has(> product-form) .product-form,
        product-info .product-form__buttons {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
          overflow: visible !important;
        }

        product-info .product-form__buttons {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
          gap: 0.6rem !important;
          align-items: stretch !important;
          justify-content: stretch !important;
          margin-right: 0 !important;
          margin-left: 0 !important;
        }

        product-info .product-form__buttons > *,
        product-info .product-form__buttons button,
        product-info .product-form__buttons shopify-payment-button,
        product-info .product-form__buttons shopify-accelerated-checkout,
        product-info .product-form__buttons shopify-paypal-button,
        product-info .product-form__buttons .paypal-buttons,
        product-info .product-form__buttons .component-frame {
          display: block !important;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
          flex: 1 1 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const isGerman = document.documentElement.lang?.toLowerCase().startsWith('de');
  const shippingTitle = isGerman ? 'Versandinformationen' : 'Shipping information';
  const newsletterSubmitText = isGerman ? 'ABONNIEREN' : 'SUBSCRIBE';

  if (!document.getElementById('codex-footer-label-fixes')) {
    const style = document.createElement('style');
    style.id = 'codex-footer-label-fixes';
    style.textContent = `
      .footer__newsletter .newsletter-form__button[data-codex-newsletter-text]::after {
        content: attr(data-codex-newsletter-text) !important;
      }
    `;
    document.head.appendChild(style);
  }

  function normalizeFooterLabels() {
    document
      .querySelectorAll(
        '.footer__localization a, .footer__localization button, .footer__localization span, .footer__localization option'
      )
      .forEach((element) => {
        const text = element.textContent.trim().toLowerCase();
        if (text === 'deutsch' || text === 'german') {
          element.textContent = 'German';
        } else if (text === 'englisch' || text === 'english' || text === 'neglish') {
          element.textContent = 'English';
        }
      });

    document.querySelectorAll('.footer__newsletter .newsletter-form__button').forEach((button) => {
      button.setAttribute('aria-label', newsletterSubmitText);
      button.dataset.codexNewsletterText = newsletterSubmitText;
    });
  }

  normalizeFooterLabels();
  window.setTimeout(normalizeFooterLabels, 250);
  window.setTimeout(normalizeFooterLabels, 1000);

  const isMobileProduct = window.matchMedia('(max-width: 749px)').matches;

  document.querySelectorAll('product-info').forEach((productInfo) => {
      const infoContainer = productInfo.querySelector('.product__info-container');
      const title = productInfo.querySelector('.product__title');
      const heading = title?.querySelector('h1');
      const gallery = productInfo.closest('[id^="MainProduct-"]')?.querySelector('media-gallery');
      const mainViewer = gallery?.querySelector('slider-component[id^="GalleryViewer-"]');
      const realCounter = mainViewer?.querySelector('.slider-counter');
      const total =
        realCounter?.querySelector('.slider-counter--total')?.textContent?.trim() ||
        String(gallery?.querySelectorAll('.product__media-item').length || 1);

      if (isMobileProduct) {
        title?.querySelectorAll('.codex-product-vendor').forEach((vendor) => vendor.remove());
      }

      if (infoContainer && heading && !infoContainer.querySelector('.codex-mobile-media-nav')) {
        const nav = document.createElement('div');
        nav.className = 'codex-mobile-media-nav';
        nav.dataset.count = total;
        nav.innerHTML = `
          <span class="codex-mobile-media-nav__count"><span class="codex-mobile-media-nav__current">1</span> of <span class="codex-mobile-media-nav__total">${total}</span></span>
        `;
        infoContainer.insertBefore(nav, title);

        const updateNav = () => {
          const current = realCounter?.querySelector('.slider-counter--current')?.textContent?.trim() || '1';
          nav.querySelector('.codex-mobile-media-nav__current').textContent = current;
        };

        if (realCounter) {
          new MutationObserver(updateNav).observe(realCounter, {
            childList: true,
            characterData: true,
            subtree: true,
          });
        }

        updateNav();
      }

      if (isMobileProduct) {
        const tax = infoContainer?.querySelector(':scope > .product__tax');
        const productFormWrapper = infoContainer?.querySelector(':scope > div:has(> product-form)');
        if (tax && productFormWrapper && tax.previousElementSibling !== productFormWrapper) {
          productFormWrapper.insertAdjacentElement('afterend', tax);
        }

        if (productFormWrapper) {
          infoContainer.style.setProperty('row-gap', '0px', 'important');
          productFormWrapper.style.setProperty('margin-top', '5px', 'important');
          infoContainer.querySelector(':scope > [id^="price-"]')?.style.setProperty('margin-bottom', '0px', 'important');

          const buttonGroup = productFormWrapper.querySelector('.product-form__buttons');
          if (buttonGroup) {
            buttonGroup.style.setProperty('display', 'grid', 'important');
            buttonGroup.style.setProperty('grid-template-columns', 'minmax(0, 1fr) minmax(0, 1fr)', 'important');
            buttonGroup.style.setProperty('gap', '6px', 'important');
            buttonGroup.style.setProperty('width', '100%', 'important');
            buttonGroup.style.setProperty('max-width', '100%', 'important');
            buttonGroup.style.setProperty('min-width', '0', 'important');
            buttonGroup.style.setProperty('box-sizing', 'border-box', 'important');
            buttonGroup.style.setProperty('overflow', 'visible', 'important');

            buttonGroup.querySelectorAll(':scope > *, button, shopify-payment-button, shopify-accelerated-checkout, shopify-paypal-button, .paypal-buttons, .component-frame').forEach((element) => {
              element.style.setProperty('display', 'block', 'important');
              element.style.setProperty('width', '100%', 'important');
              element.style.setProperty('max-width', '100%', 'important');
              element.style.setProperty('min-width', '0', 'important');
              element.style.setProperty('box-sizing', 'border-box', 'important');
            });
          }
        }
      }
  });

  document.querySelectorAll('.accordion__title, h2, h3').forEach((element) => {
    const text = element.textContent.trim().toLowerCase();
    if (text === 'versand und retouren' || text === 'shipping and returns') {
      element.textContent = shippingTitle;
    }
  });

  function normalizeProductPriceCurrency() {
    document.querySelectorAll('product-info .price-item').forEach((element) => {
      const currentText = element.textContent.trim();
      const withoutCurrencyCode = currentText.replace(/\s+[A-Z]{3}\s*$/i, '');
      if (withoutCurrencyCode !== currentText) element.textContent = withoutCurrencyCode;
    });
  }

  normalizeProductPriceCurrency();
  document.querySelectorAll('product-info [id^="price-"]').forEach((price) => {
    new MutationObserver(normalizeProductPriceCurrency).observe(price, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  });

  document.querySelectorAll('.cart__footer .tax-note, .cart-drawer .tax-note').forEach((element) => {
    const link = element.querySelector('a');
    if (link) {
      link.textContent = isGerman ? 'Versand' : 'shipping';
      element.replaceChildren(
        document.createTextNode(isGerman ? 'Rabatte und ' : 'Discounts and '),
        link,
        document.createTextNode(isGerman ? ' werden beim Checkout berechnet.' : ' calculated at checkout.')
      );
    } else {
      element.textContent = isGerman
        ? 'Rabatte und Versand werden beim Checkout berechnet.'
        : 'Discounts and shipping calculated at checkout.';
    }
  });

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest('product-info form[data-type="add-to-cart-form"]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton?.getAttribute('aria-disabled') === 'true' || submitButton?.disabled) return;

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = new FormData(form);

      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      }

      try {
        const response = await fetch(routes.cart_add_url, config);
        const data = await response.json();
        if (data?.status) throw new Error(data.description || data.message || 'Cart error');
        window.location.href = routes.cart_url || '/cart';
      } catch (error) {
        console.error('[Dawn] Add-to-cart redirect failed.', error);
      } finally {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a, button');
    if (!trigger) return;

    const text = trigger.textContent.trim().toLowerCase();
    if (text !== 'weiter shoppen' && text !== 'continue shopping') return;

    if (
      trigger.closest('cart-drawer, cart-items, cart-notification') ||
      trigger.getAttribute('href') === '/collections/all'
    ) {
      event.preventDefault();
      window.location.href = '/';
    }
  });

  const desktopProductQuery = window.matchMedia('(min-width: 990px)');
  const alignDesktopPurchaseSpacing = () => {
    if (!desktopProductQuery.matches) return;

    document.querySelectorAll('product-info').forEach((productInfo) => {
      const infoContainer = productInfo.querySelector('.product__info-container');
      const price = infoContainer?.querySelector(':scope > [id^="price-"]');
      const purchaseWrapper = infoContainer?.querySelector(':scope > div:has(> product-form)');
      if (!infoContainer || !price || !purchaseWrapper) return;

      infoContainer.style.setProperty('row-gap', '0px', 'important');
      price.style.setProperty('margin-bottom', '0px', 'important');
      purchaseWrapper.style.setProperty('margin-top', '0px', 'important');
      purchaseWrapper.style.setProperty('transform', 'none', 'important');

      purchaseWrapper.style.setProperty('margin-top', '8px', 'important');
    });
  };

  alignDesktopPurchaseSpacing();
  window.setTimeout(alignDesktopPurchaseSpacing, 250);
  window.setTimeout(alignDesktopPurchaseSpacing, 1000);
  window.addEventListener('resize', alignDesktopPurchaseSpacing);
  document.addEventListener('change', (event) => {
    if (event.target.closest('product-info')) window.setTimeout(alignDesktopPurchaseSpacing, 80);
  });
}

function collectCartSections() {
  const sections = new Map();

  for (const element of document.querySelectorAll(DAWN_CART_TAGS.join(','))) {
    let entries;
    try {
      entries = element.getSectionsToRender?.();
    } catch {
      entries = [];
    }

    for (const entry of entries ?? []) {
      if (DAWN_REFRESHED_SECTIONS.has(`${element.tagName.toLowerCase()}:${entry.id}`)) continue;

      const sectionId = entry.section ?? entry.id;
      if (!sectionId || sections.has(sectionId)) continue;

      const root = entry.section ? document.getElementById(entry.id) : document;
      const mount = entry.selector
        ? root?.querySelector(entry.selector) ?? (entry.section ? root : null)
        : document.getElementById(entry.id);
      if (!mount) continue;

      sections.set(sectionId, {
        mount,
        extractSelector: entry.selector || '.shopify-section',
      });
    }
  }

  return sections;
}

async function refreshDawnCartUI() {
  const sections = collectCartSections();
  const sectionsQuery = sections.size ? `?sections=${[...sections.keys()].join(',')}` : '';
  const cartUrl = (typeof routes !== 'undefined' && routes?.cart_url) || '/cart';
  const cartData = await fetch(`${cartUrl}.js${sectionsQuery}`, { headers: { Accept: 'application/json' } })
    .then((response) => (response.ok ? response.json() : null))
    .catch(() => null);

  if (cartData?.sections) {
    for (const [id, { mount, extractSelector }] of sections) {
      const html = cartData.sections[id];
      if (!html) continue;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(extractSelector);
      if (source) mount.replaceChildren(...source.childNodes);
    }
  }

  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: 'external-refresh',
    cartData: cartData ?? undefined,
  });
}

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.openCart.configure({
    async handler(defaultHandler) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      return defaultHandler();
    },
  });

  actions.updateCart.configure({
    eventTarget: () => document,
    async handler(defaultHandler) {
      const result = await defaultHandler();
      try {
        await refreshDawnCartUI();
      } catch (error) {
        console.error('[Dawn] Standard Actions cart refresh failed; reloading.', error);
        window.location.reload();
      }
      return result;
    },
  });
}

if (window.Shopify?.actions) {
  initStandardActions();
} else {
  document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCodexMobileFixes, { once: true });
} else {
  initCodexMobileFixes();
}

